import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { CustomerName, CustomerClassifier } from '../../services/common-utility.service';
import { DOCUMENT, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app-islington.component.html',
    styleUrls: ['./app-islington.component.css']
})
export class AppIslingtonComponent implements OnInit {

    @ViewChild('sidenav') sidenav: MatSidenav;

    constructor(private customerClassifier: CustomerClassifier,
        private titleService: Title, @Inject(DOCUMENT) private document: HTMLDocument) {
        customerClassifier.setCustomerFlag(CustomerName.ISLINGTON);
    }

    ngOnInit() {
        this.document.getElementById('appFavIcon').setAttribute('href', '/assets/images-islington/favicon.ico');
        this.titleService.setTitle('Islington Center for English');
    }

    toggleSidenav = () => {
        this.sidenav.toggle();
    }

    ngAfterViewInit() {
        window['_fs_debug'] = false;
        window['_fs_host'] = 'fullstory.com';
        window['_fs_org'] = 'GQ6YV';
        window['_fs_namespace'] = 'FS';
        (function (m, n, e, t, l, o, g, y) {
            if (e in m) { if (m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'); } return; }
            g = m[e] = function (a, b, s) { g.q ? g.q.push([a, b, s]) : g._api(a, b, s); }; g.q = [];
            o = n.createElement(t); o.async = 1; o.src = 'https://' + window['_fs_host'] /*_fs_host*/ + '/s/fs.js';
            y = n.getElementsByTagName(t)[0]; y.parentNode.insertBefore(o, y);
            g.identify = function (i, v, s) { g(l, { uid: i }, s); if (v) g(l, v, s) }; g.setUserVars = function (v, s) { g(l, v, s) }; g.event = function (i, v, s) { g('event', { n: i, p: v }, s) };
            g.shutdown = function () { g("rec", !1) }; g.restart = function () { g("rec", !0) };
            g.consent = function (a) { g("consent", !arguments.length || a) };
            g.identifyAccount = function (i, v) { o = 'account'; v = v || {}; v.acctId = i; g(o, v) };
            g.clearUserCookie = function () { };
        })(window, document, window['_fs_namespace'], 'script', 'user');
    }
}



// WEBPACK FOOTER //
// ./src/app/customizations/islington/app-islington.component.ts